import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import _Suggestions from "../../generic/_Suggestions";

const ShortUrls = (props) => {
  const { onChange } = props;
  const { values } = useFormikContext();
  const { listShortLinks } = values;

  return (
    <Dropdown>
      <Dropdown.Toggle size="sm" variant="secondary">
        URLs Cortas
      </Dropdown.Toggle>
      <Dropdown.Menu className="px-4 py-1.5 w-[300px] h-[400px] overflow-y-auto">
        <_Suggestions
          placeholder="https://..."
          handleChange={onChange}
          options={
            listShortLinks?.map((item) => ({
              value: item.shortlinks,
              label: item.displayname,
            })) || []
          }
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};

ShortUrls.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default ShortUrls;
